module.exports = __webpack_public_path__ + "static/media/knight_shield.5e718b3b.png";